import { Subject } from 'rxjs';

export interface ShipmentModel {
  shipmentFileId: number;
  fileName: string;
  orderID: number;
  numberOfDevices: number;
  numberOfErrors: number;
  status: string;
  uploadDate: string;
}

export interface ShipmentsResponseModel {
  shipments: ShipmentModel[];
  numberOfItems: number;
}

export interface ShipmentsFilter {
  limit: number;
  offset: number;
}

export interface ShipmentDeviceDetails {
  deviceLDN: string;
  simStatus: string;
  customerId: string | null;
  customerName: string | null;
  installationStatus: string | null;
}

export interface ShipmentDetailsModel {
  fileName: string;
  orderID: number;
  numberOfDevices: number;
  numberOfErrors: number;
  status: string;
  uploadDate: string;
  devices: ShipmentDeviceDetails[];
}

export enum UploadingStatus {
  Loading,
  Successful,
  Failed,
}
export class ShipmentFileUploading {
  index!: number;
  file!: File;
  status!: UploadingStatus;
  cancel: Subject<void> = new Subject<void>();
}
